import React from 'react';
import { MapPinIcon, FlameIcon } from 'lucide-react';
type LocationStoryProps = {
  name: string;
  image: string;
  distance?: string;
  isHot?: boolean;
  onClick?: () => void;
};
export const LocationStory: React.FC<LocationStoryProps> = ({
  name,
  image,
  distance,
  isHot = false,
  onClick
}) => {
  return <div className="flex flex-col items-center space-y-1 cursor-pointer group" onClick={onClick} data-id="element-155">
      <div className="relative" data-id="element-156">
        <div className={`w-16 h-16 rounded-full overflow-hidden border-2 ${isHot ? 'border-secondary' : 'border-primary'} p-0.5 transition-transform group-hover:scale-105`} data-id="element-157">
          <img src={image} alt={name} className="w-full h-full object-cover rounded-full" data-id="element-158" />
        </div>
        <div className={`absolute bottom-0 right-0 ${isHot ? 'bg-secondary' : 'bg-primary'} text-white rounded-full w-5 h-5 flex items-center justify-center`} data-id="element-159">
          {isHot ? <FlameIcon size={12} data-id="element-160" /> : <MapPinIcon size={12} data-id="element-161" />}
        </div>
      </div>
      <p className="text-xs font-medium text-center w-20 truncate" data-id="element-162">{name}</p>
      {distance && <p className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full" data-id="element-163">
          {distance}
        </p>}
    </div>;
};